import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ImageBaseService {

    public urlService = environment.serverUrl + 'ws/imageBase64.php';

    constructor(
        private http: HttpClient
        
        
        ) {

    }

    public image64(url):any {
        let headers = new HttpHeaders();
        let data = { 
            image: url
        };
        let body = JSON.stringify(data);
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.urlService, body, { headers } );

    }

   public async getDimensionImage(url): Promise<any> {
    return new Promise((resolve) => {
       const img = new Image();
        img.onload = function() {
            resolve(img);
        }
        img.src = url;
    })
             
    }

 

}